import { CalendarEvent, MINUTES_BEFORE_EVENT_TO_CHECK_IN } from "toptaal-shared"

export function canCheckInToEvent(
  selectedEvent: CalendarEvent | null,
): boolean {
  if (!selectedEvent || !selectedEvent.start || !selectedEvent.end) return false

  const now = new Date()
  const eventStartTime = new Date(selectedEvent.start)
  const eventEndTime = new Date(selectedEvent.end)

  const timeDiffFromStart = eventStartTime.getTime() - now.getTime()
  const minutesDiffFromStart = timeDiffFromStart / (1000 * 60)

  const studentStatus = selectedEvent.studentStatus

  // Check-in is possible 30 minutes before the lesson, until the end of the lesson
  if (
    minutesDiffFromStart <= MINUTES_BEFORE_EVENT_TO_CHECK_IN &&
    now <= eventEndTime &&
    studentStatus === "registered"
  ) {
    return true
  }

  return false
}
